/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';

Vue.use(Vuex);

let query_results_start = {
  countries: [],
  products: [],
  countries_info: [],
  products_info: [],
  shares_dict: {},
  cube: [],
  map_cube: {
    C_Code_ISO_Alpha_2: {
      HS_6_Code: '',
      Avg6Major: 0,
      Market_Rank: 0,
      Market_REO_Count: 0,
    },
  },
  cube_Trade_Block: [],
  cube_Main_Region: [],
  cube_C_Region: [],

  cube_HS6_Code: [],
  cube_HS4_Code: [],
  cube_HS2_Code: [],
  cube_Section: [],

  dsm_history_sum: [],
  dsm_history_total_world_sum: [],
  top6: [],
};

function trade_dsm_default_state() {
  return {
    loading_indicator: false,
    get_countries_url: 'load_countries/',
    get_hsm_codes_url: 'load_hscodes/',
    get_filters_url: 'load_filters/',
    login_url: 'api/token/',
    refresh_url: 'api/refresh/',

    current_selected_tab: 0,
    productsOpen: false,
    countriesOpen: false,
    mainFilterOpen: false,
    advancedFilterOpen: false,
    selectors_disabled: true,

    last_clicked_country_box: null, //last box clicked in the countries fileter

    last_clicked_REO_map_cell: {
      arg: {
        products: [],
        markets: [],
      },
      cell: '',
      REO_row: [],
      REO_col: [],
      force_run: false,
    },

    filterIsDirty: false, //did the filter change
    updatingMarketProductCombinations: false,
    updatingMainFilters: false,

    selectors_changed_mag_currency: false,
    apply_transaction: true,
    preset_markets_selection: {},
    // this will be the current setup

    hs6_to_desc_hash_map: {}, // key value pair from hs6_code_to_desc
    hs4_to_desc_hash_map: {}, // key value pair from hs6_code_to_desc
    hs2_to_desc_hash_map: {}, // key value pair from hs6_code_to_desc
    hs2_group_to_desc_hash_map: {}, // key value pair from hs6_code_to_desc
    //
    hs4_to_hs6_map: {}, //map hs4 values to a list if hs6_values { item : values_list = [] }
    hs2_to_hs4_map: {}, //map hs4 values to a list if hs6_values { item : values_list = [] }
    hs2_groups_to_hs2_map: {}, //map hs4 values to a list if hs6_values { item : values_list = [] }

    mpmc_graph_for_comparison_left_vs_right: {
      left_value: [],
      right_value: [],
    },
    //
    dsm_filter_setttings: {
      Home_Market: '',
      Destination_Market: '',
      Destination_Country: '',
      Destination_Country_from_rop_filter: '',
      HS6_Code: '',
      HS6_Description: '',
      HS6_Code_from_top_filter: '',
      market_search_term: 'mark',
      product_search_term: 'prod',

      // max combinations
      max_combinations: 40, // for MPMC

      // apply_transaction

      // from list selectors
      list_manager_selections_country: [],
      list_manager_country: '',
      list_manager_selections_product: [],
      list_manager_product: '',
      Country_Selection: {},
      Product_Selection: {},
      Product_Combinations: {
        countries: 0,
        products: 0,
        selection_view: 'MPMC',
        results: {
          markets_count: 5200,
          products_count: 181,
          combinations: '',
          trade_value: '',
          combinations_cube: {},
          reo_summary_values: [],
        },
      },

      // from single selectors
      filter_box_selections_country: [],
      filter_box_selections_product: [],

      Filters: {
        F1: {name: '', entries: [{col_name: '', selected_value: []}]},
        F2: {name: '', entries: [{col_name: '', selected_value: []}]},
        F3: {name: '', entries: [{col_name: '', selected_value: []}]},
        F4: {name: '', entries: [{col_name: '', selected_value: []}]},

        META: {
          Data_Models: {
            Trade_History: {
              data_message: '',
            },
          },
          custom_query: {},
          export_characteristics: {
            REO_F4_1_Text: '',
            REO_F4_1_Result: false,
            REO_F4_2_Text: '',
            REO_F4_2_Result: false,
          },
          PROVINCIAL_FILTER_VALUE: [0, 100],
          home_market: '',
          model_number: '',
          fresh_start: true,
          filter_in_progress: false,
          advanced_filters_is_dirty: false,
          report_type_to_generate: 'MPMC',
          include_product_exclusions: false,
          user_id: 10,
          instituion_id: 13,
          query_results: _.clone(query_results_start),

          selections: {
            reo_clicked: {
              REO_row: [],
              REO_col: [],
            },
            products: {HS6_Code: [], HS4_Code: [], HS2_Code: [], HS2_Groups: []},
            markets: {
              C_Code: [],
              Main_Region: [],
              Sub_Region: [],
              Trade_Group: [],
            },
          },

          // exclusions
          presets: {
            load_presets: false,
            markets: {
              exclusions: [],
            },
            products: {
              exclusions: [],
            },
            filters: [
              {
                col_name: '',
                selected_values: [],
              },
            ],
            exclusions_for_display: {
              markets: {
                exclusions: [],
              },
              products: {
                exclusions: [],
              },
            },
          },

          combinations: {
            markets_count: '',
            products_count: '',
            combinations: '',
            trade_value: 0,
            combinations_cube: {},
            // reo
            reo_summary_values: [], // reo cube values
            reo_summary_values_reo_filtered: {}, //counts
            reo_summary_values_reo_filtered_markets: {}, // list of market in the cube NB does not mean a combo exists
            reo_summary_values_reo_filtered_products: {}, // list of products in the cube NB does not mean a combo exists
          },
        },
      },
      filters_updating: true,

      User: {},
      // the results below is based on the query set above
      results: {
        dsmresult: [{TW_Share_Prov: 1, ad_valorem_tariff_year: 2017}],

        top6: [],
        top6_countries: [],
        hist_impexp_tm: [],
        hist_impexp_total: [],
      },
    },

    left_sidebar_selector: [
      {
        icon: 'mdi-dolly',
        tip: 'Products',
        key: 'products_count',
        visible: true,
      },

      {
        icon: 'mdi-earth',
        tip: 'Countries',
        key: 'markets_count',
        visible: true,
      },
      {
        icon: 'mdi-filter-variant-plus',
        tip: 'DSM Filters',
        key: 'DSM Filters',
        counter: 0,
        visible: true,
      },
    ],

    product_selector: {
      selected_h6: '',
    },

    quick_selectors: [
      {
        //0
        name: 'Single Country',
        dropdown_item_name: 'C_Name', //what item from object in dropdown
        items: [], //list of objects will be set on app choose
        selected_value: '',
      },
      {
        //1
        name: 'Single Product',
        dropdown_item_name: 'HS6_Code',
        items: [],
        selected_value: '',
      },
      {
        name: 'My Countries',
        dropdown_item_name: '',
        items: [],
        selected_value: '',
      },
      {
        name: 'My Products',
        dropdown_item_name: '',
        items: [],
        selected_value: '',
      },
      {
        name: 'Display Magnitude',
        dropdown_item_name: 'unit',
        items: [
          {unit: "'000s", selected: true},
          {unit: 'Millions', selected: false},
          {unit: 'Billions', selected: false},
        ],
        selected_value: "'000s",
      },
      {
        name: 'Currency',
        dropdown_item_name: 'currency',
        items: [
          {currency: 'Rand', selected: true},
          {currency: 'Dollar', selected: false},
        ],
        selected_value: 'Dollar',
      },
    ],
  };
}

export const store = new Vuex.Store({
  strict: false,

  state: {
    app: {
      callsPending: 0,
      application_selector_open: false,
      application_selection_number: null, // which one in the array of applications is selected
      disable_getters: false, // use to disable the long list generation e.g. productSearchand Selected list
      activeDialogComponent: null,
      activeDialogComponentProps: null,
      companyName: 'Trade-Advisory',
      base_login_page: '',
      selectedApp: '', // is set after app is chosen
      selectedHomeCountry: '', // this is the country name not the code
      selectedModelVersion: '',
      selectedModelName: '',
      selectedAppExpiry: '',
      drawerRight: false,
      production: false,
      loginDialog: true,
      displayAdminPage: process.env.VUE_APP_SHOW_ADMIN === 'true',
      appVersionFrontend: process.env.VUE_APP_FRONTEND_VERSION,
      appVersionBackend: process.env.VUE_APP_BACKEND_VERSION,
      email_us_link: 'admin@tradeadvisory.co.za',
      progressMessage: '',
      value_mulitplier: {},
      user_server_message: 'Application loading.',
      exchange_rate: {
        Currency: '',
      },
      big_map: false,
      include_overview_sections_in_report: true,
      startup_with_filters: false,
      available_applications: [
        {text: '📊', value: 'trade-dsm'},
        // {text: '💾 Trade-Data Application', value: 'trade-data-app'},
        {text: '➡️', value: 'trade-crm-app-rfi-process'},
      ],
      selected_application: 'trade-dsm',
      update_filters_selection_on_each_call: false,
    },
    current_1PMC_report_seletion: 'EMF_Overview',
    excel_report_generation_in_progress: false,
    word_report_generation_in_progress: false,
    email_report_generation_in_progress: false,

    // save the reo table clicks for navigation purposes

    market_preselected_by_app: false, // did we only get one result and needed to make the selection on user behalf?
    product_preselected_by_app: false, // did we only get one result and needed to make the selection on user behalf?
    backend: {
      base_url: '',
    },

    user: {
      userServerInfo: {
        non_tw_exchange_rate: {},
        app_config: {
          local_storage_last_update_date: '',
          max_dsm_results: 1,
          max_markets: 2,
          max_products: 3,
          test_shared_tables_use: false,
          test_shared_tables_model_number: 0,
          help_dict: {},
        },

        subscriptions: [],
        user: {
          fields: {
            include_cell_phone_in_report: false,
            user_product_list: '[]',
            user_market_list: '[]',
            user: [],
            institution: [
              {
                fields: {
                  institution_name: '',
                  application_name: '',
                  product_list: [],
                  market_list: [],
                  trade_data_reports: [],
                  application_image: '',
                  referrer_url: '',
                  help_version: '',
                },
              },
            ],
          },
        },
      },

      logged_in: false,
      token: 'not logged in',
      refresh: 'not logged in',
      entity: 'DTI',
      department: 'DTI-ERPC',
      org_image_url: '../../assets/img/trade-dti-bw.png',
    },

    tradeDSM: trade_dsm_default_state(),

    tradeData: {
      trade_data_cube: {},
      trade_data_cube_loading: true,
      report_selection: 'EMF_Overview',
      report_selections: [
        {
          text: 'Export Market Finder (EMF) - CEPII historical trends',
          value: 'EMF_Overview',
        },
        // {
        //   text: 'Australian Bureau of Statistics (ABS) - Latest trade statistics for selection',
        //   value: 'ABS_Overview',
        //   url: 'generate_abs_frontend_views/',
        //   report_name: 'ABS Overview',
        //   hover_text:
        //     'Download Australian Bureau of Statistics (ABS) - Latest trade statistics',
        // },
        // {
        //   text: 'SARS - Latest trade statistics for selection',
        //   value: 'SARS_Overview',
        //   url: 'generate_sars_frontend_views/',
        //   report_name: 'SARS Overview',
        //   hover_text:
        //     'Download South African Revenue Service (SARS) - Latest trade statistics',
        // },
      ],
    },

    crmData: {
      application_name: '',
      active_tab: 0,
      active_process_tab: -1,
      tab_history: [],
      process_tab_history: [],

      user: {
        user_tags: [
          'Africa',
          'North-West',
          'Randburg',
          'Cape',
          'Durban',
          'Apples',
          'Local developers',
          'Nuts',
        ],
      },
      all_crm_companies: [],
      selected_company: {
        company_info: null,
        company_tags: ['Africa'],
      },
      DEBUG: [],
      // RFI
      request_for_information_template: {
        id: 1,
        workflow_name: '',
        owner_id: 1,
        status: '',
        creator: '',
        company_id: 1,
        company_contact_id: 1,
        note: '',
        products: [],
        markets: [],
        documents: [
          {name: '', type: 'png', base64_blob: ''},
          {name: '', type: 'file', base64_blob: ''},
          {name: '', type: 'jpeg', base64_blob: ''},
        ],
      },
      new_request_for_information: {},
      requests_for_information_list: [
        {
          id: 1,
          status: 'OPEN',
          creator: 'Tobie Nortje',
          company: 1,
          note: 'Report for Trade Advisory',
        },
        {
          id: 2,
          status: 'OPEN',
          creator: 'Tobie Nortje',
          company: 2,
          note: 'Report for Martin',
        },
      ],
    },
  },

  mutations: {
    set_results_cube_to_empty(state) {
      // console.log('Setting this thing smaller...');
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results = _.clone(
        query_results_start,
      );
    },
    set_HS6_Code_selection(state, products) {
      state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = products;
    },
    set_C_Code_selection(state, markets) {
      state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = markets;
    },
    set_trade_date_cube(state, cube) {
      state.tradeData.trade_data_cube = cube;
    },
    set_user_message(state, msg) {
      state.app.user_server_message = msg;
    },
    set_provincial_share_filter(state, share) {
      this.state.tradeDSM.dsm_filter_setttings.Filters.META.PROVINCIAL_FILTER_VALUE = share;
    },
    clear_circ_ref_error(state) {
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube.forEach(
        v => delete v.name,
      );
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube_Main_Region.forEach(
        v => delete v.name,
      );
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube_C_Region.forEach(
        v => delete v.name,
      );
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube_Trade_Block.forEach(
        v => delete v.name,
      );
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube_HS6_Code.forEach(
        v => delete v.name,
      );
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube_HS4_Code.forEach(
        v => delete v.name,
      );
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube_HS2_Code.forEach(
        v => delete v.name,
      );
      state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube_Section.forEach(
        v => delete v.name,
      );
    },
    set_advanced_filters_is_dirty(state, bool) {
      state.tradeDSM.dsm_filter_setttings.Filters.META.fresh_start = !bool;
      state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = bool;
    },
    set_dsm_filters_loading(state, loading) {
      // Change the state of the main filters loading
      // True = loading
      // False = finished loading or error
      state.tradeDSM.filters_updating = loading;
    },
    set_dsm_filters(state, filters) {
      // state.tradeDSM.dsm_filter_setttings.Filters = JSON.parse(JSON.stringify(filters));
      state.tradeDSM.dsm_filter_setttings.Filters = filters;
    },
    set_dsm_filters_no_parsing(state, filters) {
      state.tradeDSM.dsm_filter_setttings.Filters = filters;
    },
    set_dsm_filters_from_localforage(state, filters) {
      state.tradeDSM.dsm_filter_setttings.Filters = filters;
    },
    set_dsm_filters_meta(state, filters) {
      state.tradeDSM.dsm_filter_setttings.Filters.META = JSON.parse(
        JSON.stringify(filters),
      );
    },
    set_country_search_term(state, term) {
      state.tradeDSM.dsm_filter_setttings['market_search_term'] = term;
    },

    set_product_search_term(state, term) {
      state.tradeDSM.dsm_filter_setttings['product_search_term'] = term;
    },

    set_selectors_state(state, v) {
      state.tradeDSM.selectors_disabled = v;
    },
    reset_trade_dsm_app(state) {
      state.tradeDSM = trade_dsm_default_state();

      state.tradeDSM.quick_selectors[0].items = JSON.parse(
        localStorage.getItem('dsm_countries'),
      );

      state.tradeDSM.quick_selectors[1].items = JSON.parse(
        localStorage.getItem('dsm_codes'),
      );
    },
    set_trade_dsm_state(state, obj) {
      state.tradeDSM.dsm_filter_setttings.Filters = obj;
    },

    set_exchange_rate(state, value) {
      // console.log('settinf exchange rate');
      // console.log(value);
      state.app.exchange_rate = value;
    },
    set_value_mulitplier(state, multiplier) {
      // console.log('settinf multiplier');
      // console.log(multiplier);
      state.app.value_mulitplier = multiplier;
    },
    set_list_name_country(state, name) {
      state.tradeDSM.dsm_filter_setttings.list_manager_country = name;
    },
    set_list_name_product(state, name) {
      state.tradeDSM.dsm_filter_setttings.list_manager_product = name;
    },
    set_list_manager_selection_country(state, entry) {
      // entry = {list_type:product|country, list_contents:list}
      if (entry && entry[0] !== null) {
        state.tradeDSM.dsm_filter_setttings.list_manager_selections_country = entry;
      } else {
        state.tradeDSM.dsm_filter_setttings.list_manager_selections_country.length = 0;
      }
    },
    set_list_manager_selection_product(state, entry) {
      // entry = {list_type:product|country, list_contents:list}
      if (entry && entry[0] !== null) {
        state.tradeDSM.dsm_filter_setttings.list_manager_selections_product = entry;
      } else {
        state.tradeDSM.dsm_filter_setttings.list_manager_selections_product.length = 0;
      }
    },
    set_filter_box_selection_country(state, entry) {
      // entry = {list_type:product|country, list_contents:list}
      state.tradeDSM.dsm_filter_setttings.filter_box_selections_country = entry;
    },
    set_filter_box_selection_product(state, entry) {
      // entry = {list_type:product|country, list_contents:list}
      state.tradeDSM.dsm_filter_setttings.filter_box_selections_product = entry;
    },

    setHomeCountry(state, country) {
      state.app.selectedHomeCountry = country;
    },

    setHomeMarket(state, home_market) {
      state.tradeDSM.dsm_filter_setttings.Home_Market = home_market;
    },
    setModelVersion(state, code) {
      state.app.selectedModelVersion = code;
    },
    setModelName(state, name) {
      state.app.selectedModelName = name;
    },
    setUserInfo(state, info) {
      state.user.userServerInfo = info;
    },
    setProgressMessage(state, m) {
      state.app.progressMessage = m;
    },
    setFilterIsDirty(state, b) {
      state.tradeDSM.filterIsDirty = b;
    },
    loginSuccess(state) {
      state.user.logged_in = true;
    },
    logout(state) {
      state.user.logged_in = false;
    },
    appExpiryDate(state, expiryDate) {
      state.app.selectedAppExpiry = expiryDate;
    },
    appSelected(state, appName) {
      state.app.selectedApp = appName;
    },
    setBaseUrl(state, url) {
      state.backend.base_url = url;
    },
    setCountriesList(state, countriesList) {
      state.tradeDSM.quick_selectors[0].items = countriesList;
    },

    setDsmCodesList(state, dsmCodesList) {
      state.tradeDSM.quick_selectors[1].items = dsmCodesList;
    },
    setQuickFilterSelectionCountry(state, {name, event}) {
      // eslint-disable-next-line no-console
      console.log(name, event);
      state.tradeDSM.quick_selectors[0].selected_value = event;
    },
    setQuickFilterSelectionCode(state, {name, event}) {
      // eslint-disable-next-line no-console
      console.log(name, event);
      state.tradeDSM.quick_selectors[1].selected_value = event;
    },
    setProductSelection(state, code) {
      state.tradeDSM.product_selector.selected_h6 = code;
    },
    toggleCountriesFilter(state, bool) {
      state.tradeDSM.countriesOpen = bool;
    },
    toggleProductsFilter(state, bool) {
      state.tradeDSM.productsOpen = bool;
    },
    toggleMainFilter(state, bool) {
      state.tradeDSM.mainFilterOpen = bool;
    },
    toggleAdvancedFilter(state, bool) {
      state.tradeDSM.advancedFilterOpen = bool;
    },

    setCombinationsTradeValue(state, response_count_object) {
      state.tradeDSM.dsm_filter_setttings.Product_Combinations.results = response_count_object;
    },

    setDSM_Product_Combinations(state, obj) {
      let k = Object.keys(obj)[0];
      let v = obj[k];
      state.tradeDSM.dsm_filter_setttings.Product_Combinations[k] = v;
      let C_Count =
        state.tradeDSM.dsm_filter_setttings.Product_Combinations.results['markets_count'];
      let P_Count =
        state.tradeDSM.dsm_filter_setttings.Product_Combinations.results[
          'products_count'
        ];

      if (C_Count === 1 && P_Count === 1) {
        state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'] =
          '1P1C';
      }

      if (C_Count === 0 && P_Count === 1) {
        state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'] =
          '1P1C';
      }
      if (C_Count === 1 && P_Count === 0) {
        state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'] =
          '1P1C';
      }
      if (C_Count === 0 && P_Count === 0) {
        state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'] =
          '1P1C';
      }
      if (C_Count > 1 && P_Count === 1) {
        state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'] =
          '1PMC';
      }
      if (C_Count === 1 && P_Count > 1) {
        state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'] =
          'MP1C';
      }
      if (C_Count > 1 && P_Count > 1) {
        state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'] =
          'MPMC';
      }
      state.tradeDSM.dsm_filter_setttings.results.dsmresult = [];
      console.log(
        'View set to ' +
          state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'],
      );
    },
    setFilter(state, setting) {
      state.tradeDSM.dsm_filter_setttings.Filters[setting.filter_name]['entries'][
        setting.id
      ]['value'] = -123;
      state.tradeDSM.dsm_filter_setttings.Filters[setting.filter_name]['entries'][
        setting.id
      ]['selected_value'] = setting.selected_value;

      // Now clear last selected and make new last selected based on last selected filter change

      // iterate over each of the keys and set the entries all to last-selected = false;
      Object.keys(state.tradeDSM.dsm_filter_setttings.Filters).forEach(function(item) {
        if (item !== 'META') {
          state.tradeDSM.dsm_filter_setttings.Filters[item]['entries'].forEach(function(
            filter,
            filter_key,
          ) {
            state.tradeDSM.dsm_filter_setttings.Filters[item]['entries'][filter_key][
              'last_selected'
            ] = false;
          });
        }

        // console.log(item_index);
      });

      // now set the last selected as true

      state.tradeDSM.dsm_filter_setttings.Filters[setting.filter_name]['entries'][
        setting.id
      ]['last_selected'] = true;
    },
    setDSMFilterForSearch_Product(state, values) {
      console.log('Commiting product selection code', values);
      if (values.length > 0) {
        state.tradeDSM.dsm_filter_setttings['HS6_Code'] = values[0]['HS6_Code'];
      } else {
        state.tradeDSM.dsm_filter_setttings['HS6_Code'] = '';
      }
    },
    setDSMFilterForSearch_Product_Top_Filter(state, values) {
      console.log('Commiting product selection code', values);
      if (values.length > 0) {
        state.tradeDSM.dsm_filter_setttings['HS6_Code_from_top_filter'] =
          values[0]['HS6_Code'];
      } else {
        state.tradeDSM.dsm_filter_setttings[' HS6_Code_from_top_filter'] = '';
      }
    },
    setDSMFilterForSearch_ProductDict(state, values) {
      // console.log('Commiting product selection whole dict', values);
      // console.log(values);
      state.tradeDSM.dsm_filter_setttings['Product_Selection'] = values[0];
    },
    setDSMFilterForSearch_Target_Market(state, values) {
      console.log('Commit Market selection...', values);
      if (values.length > 0) {
        state.tradeDSM.dsm_filter_setttings['Destination_Market'] = values[0]['C_Code'];
        state.tradeDSM.dsm_filter_setttings['Destination_Country'] = values[0]['C_Name'];
      } else {
        state.tradeDSM.dsm_filter_setttings['Destination_Market'] = '';
        state.tradeDSM.dsm_filter_setttings['Destination_Country'] = '';
      }
    },
    setDSMFilterForSearch_Target_Market_Top_Filter(state, values) {
      console.log('Committing Market selection', values);
      if (values.length > 0) {
        state.tradeDSM.dsm_filter_setttings['Destination_Country_from_rop_filter'] =
          values[0]['C_Name'];
      } else {
        state.tradeDSM.dsm_filter_setttings['Destination_Country_from_rop_filter'] = '';
      }
    },
    setDSMFilterForSearch_Target_MarketDict(state, values) {
      console.log('Commmiting Market selection', values);
      state.tradeDSM.dsm_filter_setttings['Country_Selection'] = values[0];
    },
    setDSMResult(state, obj) {
      // console.log('Setting DSM Results', typeof obj, obj);
      state.tradeDSM.dsm_filter_setttings.results['dsmresult'] = obj;
    },
    setTop6Result(state, obj) {
      // console.log('Setting Top6 Results', typeof obj, obj);
      state.tradeDSM.dsm_filter_setttings.results['top6'] = obj;
    },
    setHistImpExpTmResult(state, obj) {
      // console.log('Setting hist_impexp_tm Results', typeof obj, obj);
      state.tradeDSM.dsm_filter_setttings.results['hist_impexp_tm'] = obj;
    },
    setHistImpexpTotalResult(state, obj) {
      // console.log('Setting hist_impexp_total Results', typeof obj, obj);
      state.tradeDSM.dsm_filter_setttings.results['hist_impexp_total'] = obj;
    },
    setTop6ResultCountries(state, obj) {
      // console.log('Setting Top6 Results Countries', typeof obj, obj);
      state.tradeDSM.dsm_filter_setttings.results['top6_countries'] = obj;
    },
    setLoadingIndicator(state, value) {
      state.tradeDSM.loading_indicator = value;
    },
    setupdatingMarketProductCombinations(state, value) {
      state.tradeDSM.updatingMarketProductCombinations = value;
    },
    set_current_selected_tab(state, value) {
      state.tradeDSM.current_selected_tab = value;
    },
  },

  getters: {
    single_product(state) {
      return state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
        .HS6_Code[0];
    },

    home_market_code(state) {
      return state.tradeDSM.dsm_filter_setttings['Home_Market'];
    },
    is_run_cube_valid: function(state) {
      // Will check if the combinations is valid to pull a cube from the backend
      // 1P1C - NA
      // 1PMC - Number of countries in results < settings
      // MP1C - Number of products in resuls = < settings
      // MPMC - Number of combinations < settings
      // return true or false
      let results_count =
        state.tradeDSM.dsm_filter_setttings.Filters.META.combinations.combinations;
      let max_results = state.user.userServerInfo.app_config.max_dsm_results;

      return results_count <= max_results && results_count !== 0;
    },
    productSearchAndSelectedList: function(state) {
      // this is the one called by the product box
      if (!state.app.disable_getters) {
        console.log('Products search and selector is running.');
        let full_list = [];

        // reference to the current filter results
        const META = state.tradeDSM.dsm_filter_setttings.Filters.META;
        const filter_results = META.query_results.products.sort();
        // const filter_results_length = filter_results.length;
        const selections = META.selections.products;
        const productsList = state.tradeDSM.quick_selectors[1].items;

        // This can be set at runtime, no need to call this every time
        const product_list = productsList
          .filter(val => {
            return META.presets.products.exclusions
              .map(v => v.HS6_Code)
              .indexOf(val.HS6_Code);
          })
          .sort();

        const product_list_length = product_list.length;

        // const keys = Object.keys(META.selections.products);
        let keys = [];
        if (META.selections.products.HS6_Code.length > 0) {
          keys.push('HS6_Code');
        }
        if (META.selections.products.HS4_Code.length > 0) {
          keys.push('HS4_Code');
        }
        if (META.selections.products.HS2_Code.length > 0) {
          keys.push('HS2_Code');
        }
        if (META.selections.products.HS2_Groups.length > 0) {
          keys.push('HS2_Groups');
        }
        // {HS6_Code: [], HS4_Code: [], HS2_Code: [], HS2_Groups: []},

        // iterate through the main product list
        for (let i = 0; i < product_list_length; i++) {
          // go through all 6,000 products
          // check if in the cube results and add key
          let product_item = product_list[i];

          product_item['in_cube'] = filter_results.length === 0;
          product_item['in_search'] = true;
          product_item['HS6_Code_Selected'] = false;

          product_item['HS4_Code_Selected'] = false;
          product_item['HS4_Code_in_cube'] = false;

          product_item['HS2_Code_Selected'] = false;
          product_item['HS2_Code_in_cube'] = false;

          product_item['HS2_Groups_Selected'] = false;
          product_item['HS2_Groups_in_cube'] = false;

          if (filter_results.includes(product_item['HS6_Code'])) {
            product_item['in_cube'] = true;
          }
          // for (let search = 0; search < filter_results_length; search++) {
          //   let search_item = filter_results[search];
          //
          //   // only show th code if it is in the results set
          //   // override preset filter
          //
          //   if (product_item['HS6_Code'] === search_item) {
          //     product_item['in_cube'] = true;
          //     break;
          //   }
          // }

          //override all if the list is empty then all is selected by default
          // if (filter_results.length === 0) {
          //   product_item['in_cube'] = true;
          // }

          // selected?
          // iterate through the 4 keys

          keys.forEach(key => {
            // e.g hs6, hs4, hs2
            for (let selection = 0; selection < selections[key].length; selection++) {
              // cycle through eacg selection list
              let selected_term = selections[key][selection];
              // name of selection this is equivalent to a tick on the item in the box
              if (product_item[key] === selected_term) {
                // if the item in the list is the item  in the full list
                if (product_item[`${key}_Selected`]) {
                  // toggle to false is selected
                  product_item[`${key}_Selected`] = false;
                  //need to remove from the selections list then
                  // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                  META.selections.products[key] = [
                    ...META.selections.products[key].filter(v => v !== selected_term),
                  ];
                } else {
                  // else the product item is made true
                  product_item[`${key}_Selected`] = true;
                }
                break;
              }
            }
          });

          full_list.push(product_item);
        }
        // console.table(full_list);
        return full_list;
      } else {
        ('Skipped the update since we are busy one server');
        return [];
      }
    },

    get_advanved_filters_is_dirty: state =>
      state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty,
    get_filters_loading_status: state => state.tradeDSM.filters_updating,
    get_current_selected_tab: state => state.tradeDSM.current_selected_tab,
    get_product_search_term: state =>
      state.tradeDSM.dsm_filter_setttings.product_search_term,
    get_market_search_term: state =>
      state.tradeDSM.dsm_filter_setttings.market_search_term,

    get_selectors_state: state => state.tradeDSM.selectors_disabled,
    MarketProductCombinationsUpdating: state =>
      state.tradeDSM.updatingMarketProductCombinations,
    get_dsm_result: state => state.tradeDSM.dsm_filter_setttings.results.dsmresult[0],
    get_exchange_rate: state => state.user.userServerInfo.exchange_rate,
    get_1p1c_results: state => state.tradeDSM.dsm_filter_setttings.results,
    get_selected_app_name: state => state.app.selectedApp,

    get_list_manager_selection_country: state => {
      if (
        state.tradeDSM.dsm_filter_setttings.list_manager_selections_country.length > 0
      ) {
        return state.tradeDSM.dsm_filter_setttings.list_manager_selections_country;
      } else {
        return [];
      }
    },

    get_list_manager_selection_product: state => {
      if (
        state.tradeDSM.dsm_filter_setttings.list_manager_selections_product.length > 0
      ) {
        return state.tradeDSM.dsm_filter_setttings.list_manager_selections_product;
      } else {
        return [];
      }
    },

    get_filter_box_selection_product: state => {
      if (state.tradeDSM.dsm_filter_setttings.filter_box_selections_product.length > 0) {
        return state.tradeDSM.dsm_filter_setttings.filter_box_selections_product;
      } else {
        return [];
      }
    },

    get_filter_box_selection_country: state => {
      if (state.tradeDSM.dsm_filter_setttings.filter_box_selections_country.length > 0) {
        return state.tradeDSM.dsm_filter_setttings.filter_box_selections_country;
      } else {
        return [];
      }
    },

    selectionCounts: state => state.tradeDSM.dsm_filter_setttings.Product_Combinations,
    combination_view: state =>
      state.tradeDSM.dsm_filter_setttings.Product_Combinations['selection_view'],
    user_type: state =>
      state.user.userServerInfo['user']['fields']['user_role'][0]['fields'][
        'subscriber_role'
      ],
    loading_indictor: state => state.tradeDSM.loading_indicator,
    app_data: state => state.app,
    user: state => state.user.userServerInfo.user,
    logged_in: state => state.user.logged_in,
    user_apps: state => state.user.userServerInfo.subscriptions,
    getProgressMessage: state => state.app.progressMessage,
    getFilterIsDirty: state => state.tradeDSM.filterIsDirty,
    // trade-dsm
    getDsmAppState: state => state.tradeDSM,
    // returns the loaded product list from the DB
    productsList: state => state.tradeDSM.quick_selectors[1].items,
    // returns the countries loaded from DB
    countriesSelectorList: state => state.tradeDSM.quick_selectors[0].items,
    baseUrl: state => state.backend.base_url,
    dsmFilterSettings: state => state.tradeDSM.dsm_filter_setttings,
    dsmFilters: state => state.tradeDSM.dsm_filter_setttings.Filters,

    hs6_selection_list: state => state.tradeDSM.dsm_filter_setttings['Product_Selection'],

    top6PlotData: state => {
      return {
        x: state.tradeDSM.dsm_filter_setttings.results['top6'].map(
          i => i['Supplying_Market'],
        ),
        y: state.tradeDSM.dsm_filter_setttings.results['top6'].map(i => i['Trade_Value']),
      };
    },

    historyPlotData: state => {
      return {
        x: state.tradeDSM.dsm_filter_setttings.results['hist_impexp_tm'].map(
          i => i['T_Year'],
        ),
        y: [
          state.tradeDSM.dsm_filter_setttings.results['hist_impexp_tm'].map(
            i => i['TM_ImportVal'],
          ),
          state.tradeDSM.dsm_filter_setttings.results['hist_impexp_tm'].map(
            i => i['HM_ExportVal'],
          ),
          state.tradeDSM.dsm_filter_setttings.results['hist_impexp_tm'].map(
            i => i['HM_ImportVal'],
          ),
        ],
      };
    },

    historyPlotDataTotal: state => {
      return {
        x: state.tradeDSM.dsm_filter_setttings.results['hist_impexp_total'].map(
          i => i['T_Year'],
        ),
        y: [
          state.tradeDSM.dsm_filter_setttings.results['hist_impexp_total'].map(
            i => i['World_ImportVal'],
          ),
          state.tradeDSM.dsm_filter_setttings.results['hist_impexp_total'].map(
            i => i['HM_ExportVal'],
          ),
          state.tradeDSM.dsm_filter_setttings.results['hist_impexp_total'].map(
            i => i['HM_ImportVal'],
          ),
        ],
      };
    },

    getTop6CountriesList: state =>
      state.tradeDSM.dsm_filter_setttings.results['top6_countries'],
  },

  getCRMstate: state => state.crmData,
});
